import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, Link } from 'react-router-dom';
import { Result, Button } from 'antd';

import MainLayout from '../../components/core/layouts/MainLayout';
import { RootState } from '../../store';
import { AUTH_ROUTER, MAIN_ROUTER } from '../../routers/constants';
import { canAccessRoute } from 'utils/permissions';

import LoadingScreen from 'components/core/common/Loading';

interface Props {
  children: React.ReactNode;
}

function WithMainLayoutHOC({ children }: Props) {
  const { pathname } = useLocation();
  const { isAuth, userInfo } = useSelector((state: RootState) => state.auth);
  if (!isAuth) return <Navigate to={AUTH_ROUTER.LOGIN} replace />;

  return (
    <MainLayout>
      {canAccessRoute(userInfo, pathname) ? (
        <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
      ) : (
        <Result
          status="403"
          title="403"
          subTitle="Bạn không có quyền truy cập chức năng này."
          extra={<Link to={MAIN_ROUTER.DASHBOARD_LASER}><Button type="primary">Về trang giám sát</Button></Link>}
        />
      )}
    </MainLayout>
  );
}

export default WithMainLayoutHOC;
